import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { reportError } from '@/(front-desk)/utils/functions'
import ExternalLinks from '@/(front-desk)/components/ExternalLinks'
import Report from '@/(front-desk)/components/Report'
import Link from 'next/link'
import axios from 'axios'
import logo from '@/(front-desk)/assets/images/2024/logo.png'
import accessibility from '@/(front-desk)/assets/images/footer/accessibility.png'
import moda from '@/(front-desk)/assets/images/footer/moda.png'
import edu from '@/(front-desk)/assets/images/footer/edu.png'
import ADI from '@/(front-desk)/assets/images/footer/ADI.png'
import TAIC from '@/(front-desk)/assets/images/footer/TAIC.png'
import dayjs from 'dayjs'

export const revalidate = 3600
export default function Footer() {

    const CMS = useSelector((state) => state.CMS)
    const [ reportPopup, setReportPopup ] = useState(false)
    const [ pageViews, setPageViews ] = useState(0)

    useEffect(() => {
        // API Source Code Location: repository at https://gitlab.fugufish.co/fugufc/vision-get-wild/analytics-data
        // Deployment Location: Cloudflare worker at https://dash.cloudflare.com/b7d193ae1b259a66007996bbe4e73d33/workers/services/view/analytics-data/production
        // Sample Format: {
        //     active_users: "123",
        //     screen_page_views: "123",
        //     sessions: "123"
        // }
        axios.get('https://analytics.dcaward-vgw.org.tw')
        .then((res) => {
            console.log(`${res.config?.url}: `, res.data)
            setPageViews(res.data.screen_page_views)
        })
        .catch((err) => {
            // console.log(err.config?.url, err)
            reportError(err)
        })
    }, [])

    return (
        <>
        <footer className="front-desk-footer">
            <div className="top-area">
                <div className="block">
                    <img className="logo" src={logo.src} alt="臺灣產學策進會放視大賞 Logo" />
                </div>
                <div className="flex flex-col gap-8">
                    {/* <div className="unit">指導 | {CMS.registries['cms.home.footer.director']}</div> */}
                    {/* <div className="unit">主辦 | {CMS.registries['cms.home.footer.hoster']}</div> */}
                    {/* <div className="unit">執行 | {CMS.registries['cms.home.footer.executor']}</div> */}
                    <div className="flex flex-wrap items-center gap-4">
                        <span>指導 |</span>
                        {/* <img className="w-[14.35rem]" src={moda.src} /> */}
                        <img className="w-[7.9rem]" src={edu.src} />
                    </div>
                    {/* <div className="flex items-center gap-4">
                        <span>主辦 |</span>
                        <img className="w-[15.9rem]" src={ADI.src} />
                    </div> */}
                    <div className="flex items-center gap-4">
                        <span>執行 |</span>
                        <img className="w-[13.26rem]" src={TAIC.src} />
                    </div>
                </div>
                <div className="flex flex-col gap-3 whitespace-nowrap">
                    <div className="unit">地址 | {CMS.registries['cms.home.footer.address']}</div>
                    { CMS.registries['cms.home.footer.email'] &&
                        <div className="unit">信箱 | <a href={`mailto:${CMS.registries['cms.home.footer.email']}}`}>{CMS.registries['cms.home.footer.email']}</a></div>
                    }
                    <div className="unit">電話 | {CMS.registries['cms.home.footer.phone']}</div>
                </div>
            </div>
            <div className="middle-area">
                <div className="flex-center gap-2">
                    { pageViews > 0 &&
                        <>
                        <div className="text-black-500 font-semibold">累計網站訪問</div>
                        <div className="text-[1.5rem] text-main font-zen-dots">{Number(pageViews).toLocaleString()}</div>
                        </>
                    }
                </div>
                <div className="links">
                    <ExternalLinks />
                </div>
            </div>
            <div className="bottom-area">
                <div className="copy-right">Copyright © 2023-{dayjs().format('YYYY')} 放視大賞. All Rights Reserved.</div>
                <div className="link-area">
                    <Link href="/sitemap">網站導覽</Link>
                    <Link href="/faq">常見問題</Link>
                    <Link href="/sponsor">熱情贊助</Link>
                    <Link href="/privacy">隱私權及資訊安全政策</Link>
                    <Link href="/copyright">著作權聲明</Link>
                    <button onClick={() => {setReportPopup(true)}}>問題回報</button>
                    <a
                        title="另開新視窗前往無障礙網站"
                        href="https://accessibility.moda.gov.tw/Applications/Detail?category=20240503163625"
                        target="_blank"
                    >
                        <img src={accessibility.src} alt="通過 A 檢測等級無障礙網頁檢測" />
                    </a>
                </div>
            </div>
        </footer>
        { reportPopup &&
            <Report setReportPopup={setReportPopup} />
        }
        </>
    )
}
